import { useNavigate } from 'react-router-dom';
import { useDispatch, useSelector } from 'react-redux';
import { Images } from 'assets/images';
import { WarningModal } from 'containers/Welcome/fragments/WarningModal';
import { useOutsideClick } from 'hooks/useOutsideClick';
import { ROUTES } from 'utils/routeNames';
import { useEffect } from 'react';
import { offersAction } from 'store';
import {
  ModalWrapper,
  StartButtonWrapper,
  StartYourTripsButton,
  StartYourTripsLine,
} from './styles';

export const StartYourTrip = ({ another, start }) => {
  const { user } = useSelector(({ auth }) => auth);
  const { offers } = useSelector((state) => state.offersReducer);

  const dispatch = useDispatch();

  const navigate = useNavigate();
  const { ref, isOpen, setIsOpen } = useOutsideClick();

  const handleClick = () => {
    if (
      user?.data?.birthdate === null ||
      user?.data?.country === null ||
      user?.data?.city === null ||
      user?.city?.gender === null
    ) {
      setIsOpen(true);
    } else if (user?.data?.birthdate) {
      if (offers?.length >= 3) {
        navigate(ROUTES.REQUESTS);
      } else {
        navigate(ROUTES.QUESTIONS);
      }
    } else if (another) {
      start();
    }
  };

  useEffect(() => {
    dispatch(offersAction.getOffers());
  }, []);

  return (
    <StartButtonWrapper>
      {isOpen ? (
        <ModalWrapper ref={ref}>
          <WarningModal />
        </ModalWrapper>
      ) : null}

      <StartYourTripsButton onClick={handleClick}>
        Get Started Now
      </StartYourTripsButton>
      <StartYourTripsLine src={Images.buttonLine} alt="icon" />
    </StartButtonWrapper>
  );
};
